import { render, staticRenderFns } from "./RecipientFormation.vue?vue&type=template&id=0a7a3d19&"
import script from "./RecipientFormation.vue?vue&type=script&lang=js&"
export * from "./RecipientFormation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports